"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const referral_hook_1 = require("@hooks/contracts/referral.hook");
const translation_hooks_1 = require("@hooks/translation.hooks");
const user_hooks_1 = require("@hooks/user.hooks");
const button_1 = require("@shared-modules/components/button");
const expandable_grid_1 = __importDefault(require("@shared-modules/components/expandable-grid"));
const toast_1 = require("@shared-modules/components/toast");
const clipboard_hooks_1 = __importDefault(require("@shared-modules/utils/hooks/clipboard.hooks"));
const core_1 = require("@web3-react/core");
const React = __importStar(require("react"));
const users_rating_grid_1 = require("./components/users-rating-grid");
const helper_1 = require("./helper");
require("./styles.scss");
const RefPage = () => {
    const { account } = (0, core_1.useWeb3React)();
    const [, copyText] = (0, clipboard_hooks_1.default)();
    const [toastShareTrigger, setToastShareTrigger] = React.useState();
    const translator = (0, translation_hooks_1.usePagesTranslation)("refPage");
    const copyRefLink = () => {
        setToastShareTrigger({});
        copyText(`${location.origin}/ref/${account}`);
    };
    const referralStats = (0, referral_hook_1.useMyReferralStats)();
    const { data: { referralsCount = 0 } = {} } = (0, user_hooks_1.useUserRefStats)();
    const claimBonuses = (0, referral_hook_1.useClaimRefBonuses)();
    const claimBonusesHandler = (token) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield claimBonuses(token);
        }
        catch (error) { }
    });
    return (React.createElement("div", { className: "p-profile-collections-page" },
        React.createElement("div", { className: "p-profile-collections-page__link-container" },
            React.createElement("div", { className: "p-profile-collections-page__link-label" }, translator("referralLinkLabel")),
            React.createElement("div", { className: "p-profile-collections-page__link" },
                React.createElement("div", { className: "p-profile-collections-page__link-value" },
                    location.origin,
                    "/ref/",
                    account),
                React.createElement(toast_1.Toast, { text: translator("copiedLabel"), refresher: toastShareTrigger },
                    React.createElement(button_1.Button, { type: "gray", size: "small", onClick: copyRefLink }, translator("copyButton"))))),
        React.createElement("div", { className: "p-profile-collections-page__title" }, translator("earningStatsLabel")),
        React.createElement(expandable_grid_1.default, { columns: (0, helper_1.getGridColumns)(claimBonusesHandler, translator), data: referralStats, getDataId: ({ token }) => token.address, totalRows: referralStats.length }),
        React.createElement("div", { className: "p-profile-collections-page__title" }, translator("usersStatsLabel", { referralsCount })),
        React.createElement("div", { className: "p-profile-collections-page__section" },
            React.createElement(users_rating_grid_1.UsersRatingGrid, null))));
};
exports.default = RefPage;
